import React from "react";
import { AiTwotoneFire } from "react-icons/ai";
import { motion } from "framer-motion";

const Banniere = () => {
  return (
    <motion.div className="banniere">
      <AiTwotoneFire className="banniere__fire" />
      <p className="banniere__text">
        Every monday,{" "}
        <span className="banniere__text--important">new resources </span>
        available{" "}
      </p>
      <AiTwotoneFire className="banniere__fire" />
    </motion.div>
  );
};

export default Banniere;
